module.exports = __webpack_public_path__ + "static/media/perishable.6c3fabd1.svg";